import React from 'react';

import { validate } from 'validate.js';
import { Row, Col, Modal, Button, Input, Divider, Form } from 'antd';
import { _success, _setAxios, _validationFormMsg } from '../../../../lib/Helper';
import { SelectBerkasKategoriSupervisi } from '../../../../components/select';

const schema = {
    supervisi_berkas_kategori_id: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    },
    nama: {
        presence: { allowEmpty: false, message: 'wajib diisi' },
    },
};

class FormContent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,

            visible: false,
        };
    }

    componentDidMount() {
        this.setState({
            values: {
                id: this.props.data.id || null,
                supervisi_berkas_kategori_id: this.props.data.supervisi_berkas_kategori_id || null,
                nama: this.props.data.nama || null
            },
        })
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;
        const errors = validate(values, schema);

        this.setState({
            values: values,
            errors: errors || {},
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    handleSubmit = async () => {
        const { values } = this.state
        const errors = validate(values, schema);
        if (errors) {
            return _validationFormMsg(errors)
        }
        this.setState({
            loading: true
        });
        const params = {
            supervisi_berkas_kategori_id: values.supervisi_berkas_kategori_id ? values.supervisi_berkas_kategori_id : null,
            nama: values.nama ? values.nama : null
        }

        let endpoint = "supervisi/penilaian-kinerja-guru/berkas/jenis"
        let method = "POST"
        if (values.id) {
            endpoint = endpoint + "/" + values.id
            method = "PUT"
        }

        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    render() {

        const { values } = this.state

        return (
            <Modal
                maskClosable={false}
                title={"Form Berkas Jenis"}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                closable={false}
                footer={null}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                    onFinish={this.handleSubmit}
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={24}>
                            <Form.Item label="Berkas Kategori *">
                                <SelectBerkasKategoriSupervisi
                                    defaultValue={values.supervisi_berkas_kategori_id || null}
                                    value={values.supervisi_berkas_kategori_id}
                                    onChange={(val) => {
                                        this.handleChangeSetValue("supervisi_berkas_kategori_id", val ? val : null)
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Nama Jenis *">
                                <Input
                                    style={{ width: '100%' }}
                                    name="nama"
                                    placeholder="Nama jenis"
                                    defaultValue={values.nama}
                                    value={values.nama || null}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("nama", e.target.value)
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} style={{ textAlign: "right" }}>
                            <Divider />
                            <Button onClick={this.props.hideModal} disabled={this.state.loading}>Batal</Button> &nbsp;
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>Simpan</Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        )
    }
}

export default FormContent;
